
import { ALL_CHECKBOX_DEFINITIONS } from "~/constants/checkboxDefinitions";

export default {
  props: {
    visibleNames: {
      type: Array,
      default: () => [],
      required: true
    },
    state: {
      type: Object,
      default: () => ({})
    },
    validationAttempted: {
      type: Boolean,
      default: false
    },
    invalidCheckboxNames: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    allCheckboxDefinitions() {
      return ALL_CHECKBOX_DEFINITIONS;
    }
  },
  methods: {
    isVisible(name) {
      return this.visibleNames.includes(name);
    },
    isCheckboxInvalid(name) {
      return (
        this.validationAttempted && this.invalidCheckboxNames.includes(name)
      );
    },
    handleCheckboxChange({ name, value }) {
      this.$emit("change", { name, value });
    }
  }
};
